<template>
  <div class="fieldsetBox" :style="boxStyle">

    <div class="boxHeader">
      <div v-if="$slots.header" class="boxHeaderContent">
          <slot name="header"></slot>
      </div>
    </div>

    <div class="boxContent">
      <slot name="content"></slot>
    </div>

    <div class="boxFooter">
      <div v-if="$slots.footer" class="boxFooterContent">
        <slot name="footer"></slot>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "FieldsetBox",
    props: {
      boxStyle: {}
    }
  }
</script>

<style scoped>
</style>